export default "__VITE_ASSET__989b35b0__"